"use strict";

require("core-js/modules/es6.function.name");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var getDisplayName = function getDisplayName(ReactComponent) {
  var defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';

  if (!ReactComponent) {
    return defaultName;
  }

  return ReactComponent.displayName || ReactComponent.name || defaultName;
};

var _default = getDisplayName;
exports["default"] = _default;